import { useEffect, useState } from 'react';
import Head from '../../components/UI/Head/Head';
import { ToastContainer } from 'react-toastify';
// style
import style from './legal.module.css';

const Laglice = () => {
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    window.scrollTo(0, 0);
    document.body.style.overflow = 'hidden'; // Отключаем скролл при загрузке

    const timer = setTimeout(() => {
      setLoading(false);
      document.body.style.overflow = 'visible'; // Возвращаем скролл после загрузки
    }, 500); // 1 секунда для имитации загрузки

    return () => {
      clearTimeout(timer);
      document.body.style.overflow = 'visible'; // На случай размонтирования компонента
    };
  }, []);
  return (
    <>
      {loading ? (
        <div className="loaderWrapper">
          <div className="loaderPage"></div>
        </div>
      ) : (
        <main>
          <Head url="/" />
          <div className="container">
            <div className={style.content}>
              <span className={style.text}>
                Последнее обновление: 9 апреля 2025 г
              </span>
              <div className={style.title}>
                <h2 className={style.before}>Политика конфиденциальности</h2>
              </div>

              <section className={style.privacy_policy}>
                <p>
                  Мы в <strong>Sparta</strong> обязуемся защищать и уважать вашу
                  конфиденциальность. В данной политике описано, какие данные мы
                  собираем, как мы их используем и какие у вас есть права в
                  отношении вашей информации.
                </p>

                <h3>1. Сбор информации</h3>
                <p>
                  Мы можем собирать и обрабатывать следующие персональные
                  данные:
                </p>
                <ul>
                  <li>Имя и контактные данные (телефон, email)</li>
                  <li>
                    Информация, предоставляемая при заполнении форм на сайте
                  </li>
                  <li>
                    Техническая информация: IP-адрес, тип устройства, браузер,
                    язык, данные о действиях на сайте (cookies и аналитика)
                  </li>
                </ul>

                <h3>2. Цели обработки данных</h3>
                <p>Мы используем ваши данные для следующих целей:</p>
                <ul>
                  <li>Предоставление и улучшение наших услуг</li>
                  <li>Связь с вами по вопросам заявок, услуг и событий</li>
                  <li>Персонализация пользовательского опыта</li>
                  <li>Маркетинговая рассылка (при вашем согласии)</li>
                  <li>Соблюдение требований законодательства</li>
                </ul>
                <h3>3. Хранение данных</h3>
                <p>
                  Мы храним ваши данные только столько, сколько необходимо для
                  достижения целей обработки, или в течение периода,
                  установленного законом.
                </p>

                <h3>4. Передача третьим лицам</h3>
                <p>
                  Мы не передаём ваши персональные данные третьим лицам, за
                  исключением следующих случаев:
                </p>
                <ul>
                  <li>По вашему прямому согласию</li>
                  <li>
                    Для исполнения обязательств перед вами (например, службы
                    доставки, платёжные системы)
                  </li>
                  <li>По требованию закона или регулирующих органов</li>
                </ul>
                <h3>5. Защита данных</h3>
                <p>
                  Мы принимаем технические и организационные меры для защиты
                  ваших данных от несанкционированного доступа, потери или
                  изменения.
                </p>

                <h3>6. Ваши права</h3>
                <p>Вы имеете право:</p>
                <ul>
                  <li>Запрашивать доступ к вашим данным</li>
                  <li>Требовать исправления или удаления ваших данных</li>
                  <li>Ограничивать или возражать против обработки</li>
                  <li>Отозвать согласие на обработку в любой момент</li>
                  <li>Подать жалобу в орган по защите данных</li>
                </ul>
                <h3>7. Cookies</h3>
                <p>
                  Мы используем cookies для обеспечения корректной работы сайта
                  и аналитики. Вы можете изменить настройки cookies в своём
                  браузере.
                </p>

                <h3>8. Контакты</h3>
                <p>
                  Если у вас возникли вопросы по поводу этой политики или
                  обработки ваших данных, свяжитесь с нами.
                </p>
              </section>
            </div>
          </div>
          <ToastContainer />
        </main>
      )}
    </>
  );
};
export default Laglice;
